import { Box } from '@mui/material';
import { Typography } from '@portals/core/src/components/Typography/Typography';
import { theme } from '@portals/core/src/themes/immobilien/main';
import { EmailInput } from '@portals/forms/src/components/EmailInput/EmailInput';
import { PhoneInput } from '@portals/forms/src/components/PhoneInput/PhoneInput';
import { TextInput } from '@portals/forms/src/components/TextInput/TextInput';
import { getFixedT } from 'i18next';
import React from 'react';

import { onTouchInputFieldProps } from '../../../../../../../hooks/usePreventSafariAutozoom/usePreventSafariAutozoom';
import { getStyles } from '../../EstateContact.styles';

interface ContactDataSectionProps {
  phoneRequired: boolean;
  preventSafariAutozoom: onTouchInputFieldProps;
}

const t = getFixedT(null, 'core-immobilien');

export const ContactDataSection = ({
  phoneRequired,
  preventSafariAutozoom,
}: ContactDataSectionProps): React.ReactElement => {
  const styles = getStyles(theme);

  return (
    <>
      <Typography variant="h4">{t('contactForm.contactData')}</Typography>
      <Box sx={styles.formColumnSection}>
        <TextInput
          fullWidth
          label={t('contactForm.firstName')}
          placeholder={t('contactForm.firstName')}
          name="firstName"
          type="single"
          required
          {...preventSafariAutozoom}
        />
        <TextInput
          fullWidth
          label={t('contactForm.lastName')}
          placeholder={t('contactForm.lastName')}
          name="lastName"
          type="single"
          required
          {...preventSafariAutozoom}
        />
      </Box>
      <Box sx={styles.formColumnSection}>
        <EmailInput
          fullWidth
          label={t('contactForm.email')}
          placeholder={t('contactForm.email')}
          name="email"
          type="single"
          required
          {...preventSafariAutozoom}
        />
        <PhoneInput
          fullWidth
          label={t('contactForm.phone')}
          placeholder={t('contactForm.phone')}
          name="phone"
          type="single"
          required={phoneRequired}
          {...preventSafariAutozoom}
        />
      </Box>
    </>
  );
};

ContactDataSection.displayName = 'ContactDataSection';
